import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  GridStateChange,
  MenuCallbackArgs
} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpirelease, annualPerformanceBM, annualOutingVisit, annualStatusHistroy } from '../../../models/slakpi';
import { division, department } from '../../../models/admin';
import { ToasterService } from '../../../toaster.service';
import { uniqBy } from 'lodash';
import { formatDate } from '@angular/common';
@Component({
  selector: 'annual-outing-visit',
  templateUrl: './annual-outing-visit.component.html',
  styleUrls: ['./annual-outing-visit.component.css']
})
export class AnnualOutingVisitComponent implements OnInit {
  
  
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  submitted: boolean = false;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;

  @ViewChild('statusUpdateTemplate', { static: false }) statusUpdateTemplate: TemplateRef<any>;
  @ViewChild('statusUpdateHistroyTemplate', { static: false }) statusUpdateHistroyTemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  angularGrid: AngularGridInstance;
  public PerformanceBM_data: any;
  public loading: boolean = true;
  public pageAction: string = 'add';
  public isStart:boolean=true;
  public selectedRows: any = [];
  public division_data: any;
  public department_data: any;
  public KPIMeasure_data: any;
  public Level_data: any;
  public Type_data: any;
  public bm_data: any;
  objAnnualPerformance: any = new annualPerformanceBM();
  public objAnnualOutingVisit = new annualOutingVisit();
  organizationTypeDDList = [{ value: 1, type: 'Government' }, { value: 2, type: 'Private' }, { value: 3, type: 'Semi Government' }];
    userList: any;
    login_UserID: any;
    searchText: string;
    data: any;
    histroyColumnDefinitions: any;
    outingStatusHistroyDataSet: any[];
    dataHistroy: any;
  editID: number;
  objStatusHistroy: any = new annualStatusHistroy();
  statusDDList = [{ value: 0, text: 'Draft' },{ value: 1, text: 'On Hold' }, { value: 2, text: 'In Progress' }, { value: 2, text: 'Completed' }]
  user: any = {};
  isAdmin: boolean;
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  dataSearch: any[];
  tenantUno: number;
  noDataImg: any;
  constructor(public restApi: BMApiService, public restAdminApi: AdminApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.tenantUno = this.user.tenantUno;
    this.noDataImg = this.utilityService.getnodataImage();
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission

  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Annual Outing Visit");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
     
      multiSelect: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true,
      },



    };
    this.userList = this.userService.getUserInfo();
    this.login_UserID = this.userList.id;
    this.searchText = '';
    this.getDivisions();
    this.getDepartments();
    this.getKPIMeasure();
    this.getLevel();
    this.getType();
    this.getBenchmarkable();
    this.LoadAnnualOutingVisit();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  handleSelectedRowsChanged1(e, args) {
    
    if (Array.isArray(args.rows) && this.angularGrid) {
      this.selectedRows = this.angularGrid.gridService.getSelectedRowsDataItem();
    }
  }
  

  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        
        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getDepartments() {

    let inpValue = new department();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getDepartments(inpValue)
      .subscribe(data => {
        
        this.department_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getKPIMeasure() {
    this.KPIMeasure_data = [
      { value: 1, text: 'Yes' },
      { value: 2, text: 'No' }
    ];
  }
  getLevel() {
    this.Level_data = [
      { value: 1, text: 'Divisional' },
      { value: 2, text: 'Corporate' }
    ];
  }
  getType() {
    this.Type_data = [
      { value: 1, text: 'New' },
      { value: 2, text: 'Existing' }
    ];
  }
  getBenchmarkable() {
    this.bm_data = [
      { value: 1, text: 'Yes' },
      { value: 2, text: 'No' }
    ];
  }

  
  LoadAnnualOutingVisit() {
    
    
   
    let inpValue = new annualOutingVisit();
    inpValue.userUno = this.login_UserID;
    inpValue.id = 0;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getAnnualOutingVisit(inpValue)
      .subscribe((data: any) => {
        
        
        if (data != null && data.length > 0) {

          this.data = uniqBy(data, 'id');
          const mockDataset = [];
          for (let i = 0; i < this.data.length; i++) {
            let fexpectedDate = formatDate(this.data[i].expectedVisitDate, 'dd-MM-yyyy', 'en-US');
            fexpectedDate = (fexpectedDate == "01-01-9999") ? '' : fexpectedDate;
            mockDataset[i] = {
              id: this.data[i].id,
              divisionUno: this.data[i].divisionUno,
              division: this.data[i].division,
              departmentUno: this.data[i].departmentUno,
              department: this.data[i].department,
              organization: this.data[i].organization,
              organizationType: this.data[i].organizationType,
              visitSubject: this.data[i].visitSubject,
              reason: this.data[i].reason,
              visitObjectives: this.data[i].visitObjectives,
              expectedVisitDate: this.data[i].expectedVisitDate,
              fexpectedVisitDate: fexpectedDate,//formatDate(this.data[i].expectedVisitDate, 'dd-MM-yyyy', 'en-US'),
              status: this.data[i].status,
              comment: this.data[i].comment
            };
          }
          this.dataset = mockDataset;
          this.dataSearch = mockDataset;
          if (mockDataset.length > 0) {
            this.setColnDefn();
          }
         
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
        else {
         this.dataset = [];
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

          this.dataset = [];
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
  }

  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'division', name: 'Division', field: 'division', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'division', 'division'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'department', name: 'Department', field: 'department', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'department', 'department'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'organization', name: 'Organization', field: 'organization', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'organization', 'organization'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'organizationType', name: 'Organization Type', field: 'organizationType', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'organizationType', 'organizationType'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'visitSubject', name: 'Visit Subject', field: 'visitSubject', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'visitSubject', 'visitSubject'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'fexpectedVisitDate', name: 'Expected Visit Date', field: 'fexpectedVisitDate', sortable: true, width: 50,
        type: FieldType.dateIso, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'fexpectedVisitDate', 'fexpectedVisitDate'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, width: 20,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          if (data.status == 'Draft' || data.status == '')
            return '<span  class="status-area status-yellow">Draft</span>';
          else if (data.status == 'Completed')
            return '<span  class="status-area status-green">Completed</span>';
          else if (data.status == 'In Progress')
            return '<span  class="status-area status-orange">In Progress</span>';
          else if (data.status == 'On Hold')
            return '<span  class="status-area status-red">On Hold</span>';


        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
           
            {
              command: 'edit-row', titleKey: 'Edit_ROW', positionOrder: 64, title: 'Edit',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-edit', cssClass: 'green', textCssClass: 'bold',
              action: (e, args) => {
                
                this.pageAction = 'edit';
                this.selectedRows = [];
                let data = args.dataContext;
                this.objAnnualOutingVisit = data;
                //this.objAnnualOutingVisit.expectedVisitDate = formatDate(this.objAnnualOutingVisit.expectedVisitDate, 'yyyy-MM-dd', 'en-US');

                this.objAnnualOutingVisit.expectedVisitDate = (this.objAnnualOutingVisit.expectedVisitDate != "") ? formatDate(this.objAnnualOutingVisit.expectedVisitDate, 'yyyy-MM-dd', 'en-US') : this.objAnnualOutingVisit.expectedVisitDate;
                this.objAnnualOutingVisit.expectedVisitDate = (this.objAnnualOutingVisit.expectedVisitDate == "9999-01-01") ? '' : this.objAnnualOutingVisit.expectedVisitDate;


                this.selectedRows = data;

                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 65 },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Update Status',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-refresh', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.objStatusHistroy.status = (rdata.status == '') ? 'Draft' : rdata.status;
                this.objStatusHistroy.comments = '';




                this.modalRef = this.modalService.show(
                  this.statusUpdateTemplate,
                  Object.assign({}, { class: 'gray modal-medium' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 65 },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Status History',
              iconCssClass: 'fa fa-lg fa-info-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.loadBMRequestStatusHistroy();
                this.objStatusHistroy.comments = '';
                this.modalRef = this.modalService.show(
                  this.statusUpdateHistroyTemplate,
                  Object.assign({}, { class: 'gray modal-lg' })
                );
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 65 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 66, title: 'Delete',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.deleteAnnualOutingVisit(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              }
            },
          ],
        }
      }




    ]


  }
  openModalWithClass() {
    this.pageAction = "add";
    this.objAnnualOutingVisit = new annualOutingVisit();

    //this.selTab = true;
    this.modalRef = this.modalService.show(
      this.addtemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }


  onSave(val) {
    if (!val) {
      this.toaster.show('error', 'Error', 'Please enter the required information');
    }
    else {
      this.addEditAnnualOutingVisit(this.objAnnualOutingVisit);
    }
    
    return false;
  }

  addEditAnnualOutingVisit(data1: any) {
    
    let obj= new annualOutingVisit();

    
    obj = data1;
    obj.divisionUno = this.objAnnualOutingVisit.divisionUno;
    obj.departmentUno = this.objAnnualOutingVisit.departmentUno;
    obj.userUno = this.login_UserID;
    obj.tenantUno = this.tenantUno;
    obj.organization = this.objAnnualOutingVisit.organization;
    obj.organizationType = this.objAnnualOutingVisit.organizationType;
    obj.visitSubject = this.objAnnualOutingVisit.visitSubject;
    obj.visitObjectives = this.objAnnualOutingVisit.visitObjectives;
    obj.expectedVisitDate = (this.objAnnualOutingVisit.expectedVisitDate) ? this.objAnnualOutingVisit.expectedVisitDate : new Date("9999-01-01");
    obj.status = (this.objAnnualOutingVisit.status != null && this.objAnnualOutingVisit.status != undefined) ? this.objAnnualOutingVisit.status : 'Draft';
    obj.condition = (this.pageAction == 'add') ? 0 : 1;
    this.restApi.addEditAnnualOutingVisit(obj)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' && data != 'failure') {
         // Swal.fire('Error', 'Something went wrong', 'error');
          this.selectedRows = [];
          let message = (this.pageAction == 'add') ? 'Annual Outing Visit Saved' : 'Annual Outing Visit Updated';
          this.toaster.show('success', 'Success', message);
          this.modalRef.hide();
          setTimeout(() => { this.spinner.hide(); this.loading = true; this.LoadAnnualOutingVisit(); }, 900);
       
        }
        else {
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }

  deleteAnnualOutingVisit(data1: any) {
    
    let obj = new annualOutingVisit();

    
   
    obj.id = data1.id;
    obj.userUno = this.login_UserID;
    obj.tenantUno = this.tenantUno;

    this.restApi.deleteAnnualOutingVisit(obj)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' && data != 'failure') {
         
          this.selectedRows = [];
          this.toaster.show('success', 'Success', 'Annual Performance deleted');
          // this.modalRef.hide();
          setTimeout(() => { this.spinner.hide(); this.loading = true; this.LoadAnnualOutingVisit(); }, 900);
        }
        else {

          // Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide(); 
        


        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }

  searchGrid() {
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.division && a.division.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.department && a.department.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.organization && a.organization.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.organizationType && a.organizationType.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.visitSubject && a.visitSubject.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.status && a.status.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.expectedVisitDate && a.expectedVisitDate.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.dataSearch;
  }
  onStatusSubmit(val1) {
    
    if (!val1) {
      this.toaster.show('error', 'Error', 'Please enter the required information');
      return
    }

    else {
      this.updateAnnualPerformanceStatus(this.objStatusHistroy);
    }
  }
  updateAnnualPerformanceStatus(data1: any) {
    



    let obj = new annualStatusHistroy();
    obj = data1;
    obj.id = (this.editID) ? this.editID : 0;
    obj.comments = (this.objStatusHistroy.comments) ? this.objStatusHistroy.comments : '';
    obj.status = this.objStatusHistroy.status;
    obj.userUno = this.login_UserID;
    obj.tenantUno = this.tenantUno;
    obj.flag = 'AnnualOutingVisit';
    this.restApi.updateAnnualStatus(obj)
      .subscribe(data => {

        if (data != null && data != undefined && data != '' && data != 'failure') {

          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {
          this.toaster.show('success', 'Success', 'Status Updated.');
          setTimeout(() => {
            this.objStatusHistroy = new annualStatusHistroy();
            this.spinner.hide();
            this.LoadAnnualOutingVisit();
            this.modalRef.hide();
          }, 500);


        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;

  }
  loadBMRequestStatusHistroy() {
    this.spinner.show();
    let inpValue = new annualStatusHistroy();
    inpValue.flag = 'AnnualOutingVisit';
    inpValue.id = (this.editID) ? this.editID : 0;
    inpValue.userUno = this.login_UserID;

    this.restApi.getAnnualStatus(inpValue)
      .subscribe(data => {
        

        this.dataHistroy = uniqBy(data, 'id');
        const mockDataset = [];
        for (let i = 0; i < this.dataHistroy.length; i++) {

          mockDataset[i] = {
            id: this.dataHistroy[i].id,
            itemUno: this.dataHistroy[i].itemUno,
            comments: this.dataHistroy[i].comments,
            status: this.dataHistroy[i].status,
            enteredBy: this.dataHistroy[i].enteredBy,
            enteredOn: this.dataHistroy[i].enteredOn,
            createdBy: this.dataHistroy[i].createdBy

          };
        }
        this.outingStatusHistroyDataSet = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridOutingStatusHistroyDefn();
        }
        else {
          this.setGridOutingStatusHistroyDefn();
        }

        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  setGridOutingStatusHistroyDefn() {
    let temp = this;
    this.histroyColumnDefinitions = [
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'comments', name: 'Comments', field: 'comments', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'comments', 'comments'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'createdBy', name: 'Created By', field: 'createdBy', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredOn', 'enteredOn'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'enteredBy', name: 'Modifed By', field: 'enteredBy', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredBy', 'enteredBy'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'enteredOn', name: 'Modified On', field: 'enteredOn', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredOn', 'enteredOn'),
          model: Filters.multipleSelect,

        }
      },


    ]


  }
}


